export const validatePatternString = (pattern: RegExp, value = '') => {
  return pattern.test(value)
}
